import Detail from "@/components/pages/Detail";
import DetailProvider from "@/context/detailContext";
import getServer from "@/utils/functions/function";
import React from "react";

export default function DetailPage({ data }) {
  return (
    <DetailProvider>
      <Detail villa={data} />
    </DetailProvider>
  );
}

export async function getServerSideProps(context) {
  return await getServer(context);
}
